<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>

<div class="filter-dropdown-container-dis">
  <p-floatLabel>
    <p-autoComplete id="employee" [(ngModel)]="selectedName" [suggestions]="suggestions"
      (completeMethod)="search($event)" (onSelect)="onNameSelect($event)" [forceSelection]="true" />
    <label for="employee">
      {{empNameField}}
    </label>
  </p-floatLabel>

  <app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
    aria-label="Type" placeholder="Type" customClass="districts-type-large-dropdown-adjustment" label="Type"
    [showFloatingLabel]="true"></app-dropdown>

  <app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
    (selectedValueChange)="onDistrictChange($event)" customClass="districts-district-dropdown" placeholder="District"
    label="District" [showFloatingLabel]="true"></app-dropdown>

  <app-datepicker [(ngModel)]="selectedScheduledDate" (onSelectChange)="onScheduledDateChange($event)"
    [inputlabel]="'Sched Date'"></app-datepicker>

  <div>
    <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>
    <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
  </div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" [totalRecords]="totalRecords" (onAction2ButtonClicked)="onReloadClicked()"
  [actionButtons]="actionButtons" (pageChanged)="onPageChanged($event)" (sortClicked)="onSortClicked($event)"
  (onSearchText)="onSearchText($event)" (onCellClicked)="onCellClicked($event)"></app-table>